// extracted by mini-css-extract-plugin
export default {"control":"Product_control__d-YFP","richText":"Product_richText__QUTu7"};